<template>
  <div
    class="book_surgery toggleContainer desk_inner_width"
    :class="{ active: isOpen }"
    ref="material_sensitivity"
  >
    <a
      class="book_surgery_top flex"
      href="javascript:void(0)"
      @click.prevent="isOpen = !isOpen"
    >
      <span class="title flex is--fit desk-flex--start">
        <span class="flex flex--start is--fit">
          רגישות לחומרים
          <span
            class="surgery-check flex"
            :class="{ active: surgery.no_material_sens }"
            @click.stop="onNoSensitivity"
          >
            <span class="surgery-check-ic block"></span>
            לא ידועה רגישות
          </span>
        </span>

        <span class="only-doc-fill flex">
          <img src="/assets/img/svg/doctor-fill.svg" />
          למילוי ע״י הרופא
        </span>
      </span>
      <span class="plus-wrap flex m-flex--center">
        <span class="plus"></span>
      </span>
    </a>
    <div
      v-show="isOpen"
      class="book_surgery_open toggleInner"
      :class="{ 'section-disabled': surgery.no_material_sens }"
    >
      <div class="no_mobile surg_list_head desk-flex">
        <div class="surg_list-1">תגובה*</div>
        <div class="surg_list-3">חומרה*</div>
        <div class="surg_list-3">שם חומר (בעברית)*</div>
        <div class="surg_list-5">הערות</div>
      </div>
      <MaterialSensitivityInfo
        :rows="surgery.material_sensitivity"
        @editSelectedBlock="editSelectedBlock"
        @removeSelectedBlock="removeSelectedBlock"
      />
      <div
        class="surg_list_body inner_group bg--white desk-no-pad desk-flex desk-flex--top"
      >
        <div class="add_new_row flex surg_list-1">
          <div class="add_new_row_col1 desk-hide">תגובה*</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <select2 name="" dir="rtl" v-model="formData.reaction">
                <option value="">בחר תגובה</option>
                <option>פריחה</option>
                <option>גירוד</option>
                <option>קוצר נשימה</option>
                <option>כאבי בטן</option>
                <option>רעד</option>
                <option>הקאות</option>
                <option>שלשולים</option>
                <option>חולשה</option>
                <option>ירידה ב-PLT</option>
                <option>ירידת לחץ דם</option>
                <option>נפיחות</option>
                <option>הלם אנפילקטי</option>
                <option>שוק</option>
                <option>אנגיואדמה</option>
                <option>חנק</option>
                <option>אודם</option>
                <option>אפניאה</option>
                <option>בצקת</option>
                <option>פרכוס</option>
                <option>לא ידוע</option>
                <option>אחר</option>
              </select2>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">חומרה*</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block">
              <select2 name="" dir="rtl" v-model="formData.severity">
                <option value="">בחר חומרה</option>
                <option>קלה</option>
                <option>בינוני</option>
                <option>קשה</option>
                <option>הלם</option>
                <option>בספק</option>
              </select2>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-3">
          <div class="add_new_row_col1 desk-hide">שם חומר (בעברית)*</div>
          <div class="add_new_row_col2">
            <div class="input-opacity desk-block relative">
              <div
                v-show="formData.name !== ''"
                @click="formData.name = ''"
                class="surg-clear-btn"
                :class="{ 'btn-mobile': isMobile }"
              >
                X
              </div>
              <multiselect
                placeholder=""
                v-model="formData.name"
                @search-change="onSearch"
                @close="onSearch('')"
                :options="filteredTypeheadOptions"
                :searchable="true"
                :internal-search="false"
                :allow-empty="false"
                :options-limit="limit"
              ></multiselect>
            </div>
          </div>
        </div>
        <div class="add_new_row flex surg_list-5">
          <div class="add_new_row_col1 w-100 desk-hide">הערות</div>
          <div class="input_area_opcity">
            <textarea
              v-model="formData.notes"
              placeholder="פירוט.."
              autocomplete="off"
            ></textarea>
          </div>
        </div>
        <ActionsMsgRow
          :errMsg="{ show: showErrorMessage, msg: errorMessage }"
          :isOnEdit="isEdit"
          @addBlock="addBlock"
          @removeSelectedBlock="resetRow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import MaterialSensitivityInfo from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/info/MaterialSensitivityInfo.vue";
import ActionsMsgRow from "@/components/Dashboard/Surgery/AddSurgery/Steps/SurgeryDetails/modules/ActionsMsgRow.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import typeheadSearch from "@/mixins/typehead-search.js";
import { DEFAULT_OPTIONS_LIMIT } from "@/utilities/typehead-search.js";

// Constants
const MOBILE_BREAKPOINT = 1200;

/**
 * MaterialSensitivity Component
 * Handles the material sensitivity section for surgery
 * Includes "no known sensitivity" checkbox option
 */
export default {
  name: "MaterialSensitivity",
  components: {
    MaterialSensitivityInfo,
    ActionsMsgRow,
    Multiselect
  },
  mixins: [typeheadSearch],
  data() {
    return {
      isOpen: false,
      isMobile: window.innerWidth < MOBILE_BREAKPOINT,
      // Typeahead options
      material_options: [],
      doctorHistory: null,
      // Current form data
      formData: {
        reaction: "",
        severity: "",
        name: "",
        notes: ""
      },
      // Error messages
      errorMessage: "יש למלא את כל השדות",
      showErrorMessage: false,
      // Edit state
      isEdit: false,
      editRow: null
    };
  },
  computed: {
    ...mapState("Surgery", {
      surgery: state => state.surgery,
      isEditMode: state => state.isEditMode
    }),
    ...mapGetters(["activeDoctor"]),

    /** Full options list searched by the typehead mixin */
    typeheadOptions() {
      return this.material_options;
    }
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY"]),

    /**
     * Toggles the "no known sensitivity" checkbox
     * When checked, clears the material sensitivity array
     */
    onNoSensitivity() {
      const newValue = !this.surgery.no_material_sens;
      this.SET_SURGERY({ no_material_sens: newValue });
      if (newValue) {
        // Clear the array when "no known sensitivity" is checked
        this.SET_SURGERY({ material_sensitivity: [] });
        this.clearForm();
      }
    },

    /**
     * Moves a row into edit mode
     */
    editSelectedBlock(index) {
      this.editRow = index;
      const object = { ...this.surgery.material_sensitivity[index] };
      const updated = [...this.surgery.material_sensitivity];
      updated.splice(index, 1);
      this.SET_SURGERY({ material_sensitivity: updated });
      this.formData = object;
      this.isEdit = true;
    },

    /**
     * Removes a row from the list
     */
    removeSelectedBlock(index) {
      if (this.editRow !== null && index < this.editRow) {
        this.editRow--;
      }
      const updated = [...this.surgery.material_sensitivity];
      updated.splice(index, 1);
      this.SET_SURGERY({ material_sensitivity: updated });
    },

    /**
     * Validates form data has required fields
     */
    validateObjectData(object) {
      return Boolean(object.reaction && object.severity && object.name);
    },

    /**
     * Shows/hides the error message
     * Called from parent component during validation
     */
    setError(show) {
      this.showErrorMessage = show;
      if (show) this.isOpen = true;
    },

    /**
     * Validates and adds the current form data to the list
     */
    addBlock() {
      const isAddFromEdit = this.editRow !== null;
      this.showErrorMessage = false;
      this.isEdit = false;

      const object = { ...this.formData };
      if (!this.validateObjectData(object)) {
        this.showErrorMessage = true;
        if (isAddFromEdit) this.editRow = null;
        return;
      }

      const updated = this.surgery.material_sensitivity.map(d => ({ ...d }));

      if (isAddFromEdit && this.editRow !== null) {
        updated.splice(this.editRow, 0, object);
      } else {
        updated.push(object);
      }

      this.SET_SURGERY({ material_sensitivity: updated });
      this.clearForm();
      if (isAddFromEdit) this.editRow = null;
    },

    /**
     * Clears all fields in the form
     */
    clearForm() {
      Object.keys(this.formData).forEach(key => {
        this.formData[key] = "";
      });
    },

    /**
     * Resets the form
     */
    resetRow() {
      this.clearForm();
      this.isEdit = false;
    },

    /**
     * Returns the typeahead limit based on doctor's history
     */
    limitTypehead() {
      const history = this.doctorHistory?.material_sensitivity;
      return history?.length || DEFAULT_OPTIONS_LIMIT;
    },

    /**
     * Prepends doctor's history items to the typeahead options
     */
    getTypeheadHistory(resArr) {
      const history = this.doctorHistory?.material_sensitivity;
      if (!history?.length) return resArr;
      // Filter out undefined/null values from history
      const validHistory = history.filter(Boolean);
      return [...validHistory, ...resArr];
    },

    /**
     * Fetches material options for typeahead
     */
    async getHistory() {
      if (!this.activeDoctor?.id) return;

      try {
        const resHistory = await this.$API.getDoctorHistory(
          this.activeDoctor.id
        );
        if (resHistory) this.doctorHistory = resHistory;

        const res = await this.$API.getTypehead("material_sensitivity");
        if (!res?.length) return;

        // Filter out items without material property
        const tmp = res.map(r => r.name).filter(Boolean);
        this.material_options = [...new Set(this.getTypeheadHistory(tmp))];
      } catch (error) {
        console.error("Failed to fetch material options:", error);
      }
    }
  },
  watch: {
    activeDoctor: {
      handler() {
        this.getHistory();
      },
      immediate: true
    }
  },
  mounted() {
    // Open section if material_sensitivity has content in edit mode
    if (this.isEditMode && this.surgery.material_sensitivity?.length) {
      this.isOpen = true;
    }
  }
};
</script>
